export default "__VITE_ASSET__BYOYUccT__"